import React from 'react'
import SidebarListing from '../Sidebar/SidebarListing';
import TopHeader from '../Sidebar/TopHeader';
import Dashboard from '../../../pages/Admin_pages/Dashboard/Dashboard';
import GameSetup from '../../../pages/Admin_pages/GameSetup/GameSetup';
import Reports from '../../../pages/Admin_pages/Reports/Reports';
import RolesManagement from '../../../pages/Admin_pages/RolesManagement/RolesManagement';
import TournamentManagement from '../../../pages/Admin_pages/TournamentManagement/TournamentManagement';
import Transactions from '../../../pages/Admin_pages/Transactions/Transactions';
import UiManagement from '../../../pages/Admin_pages/UiManagement/UiManagement';
import UserManagement from '../../../pages/Admin_pages/UserManagement/UserManagement';
// import Wrapper from '../../Sidebar/Wrapper';
import styled from "styled-components";
import { Outlet } from 'react-router-dom';


const MainSection = styled.div`
width: calc(100% - 300px);
margin-left: 300px;
transition: 350ms ease-in-out;
`


const AdminDashboard = () => {
  return (
    <>
      {/* <Wrapper> */}
      <div>
        <TopHeader />
         
            <SidebarListing />
         

         <MainSection className='mainSection'>
          <Outlet/>
            <Dashboard />
            {/* <GameSetup />
            <Reports />
            <RolesManagement />
            <TournamentManagement />
            <Transactions />
            <UiManagement />
            <UserManagement /> */}
            </MainSection>
          


      </div>
      {/* </Wrapper> */}
    </>
  )
}

export default AdminDashboard;
